module.exports = __webpack_public_path__ + "img/asia-admin11.8fedb3d2.png";